import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { GeoLanguageCountryOption, withAllCountryOption } from '../../../helpers/GeoLanguageHelper'
import { GeoLanguageCountrySelect } from './GeoLanguageCountrySelect'

type Props = {
  className?: string
  functionSubmit?: (data: string, type: string) => void
  options?: GeoLanguageCountryOption[]
  selectedKey: string
}

const DropdownFilterCountry: FC<Props> = ({
  className = '',
  functionSubmit,
  options = [],
  selectedKey = '',
}) => {
  return (
    <GeoLanguageCountrySelect
      className={className}
      options={withAllCountryOption(options)}
      selectedKey={selectedKey}
      allLabel={LanguageHelp('All Countries')}
      placeholder={LanguageHelp('Search country')}
      onChange={(key) => functionSubmit?.(key, 'country')}
    />
  )
}

export { DropdownFilterCountry }
